import React, { Component } from "react";

import UserFavoritesGridRows from "./UserFavoritesGridRows.js"


class UserFavorites extends Component {


  render() {

    var deckStyle = {
      backgroundColor: "black",
      color: "white"
    }

    return (
      <div className="container">
      <div id="deck" className="d-flex flex-row flex-wrap"  >
          <table id="decklist" style={deckStyle} className="table table-sm">
              <thead>
                  <tr>
                  <th>Deck Name</th>
                  <th>Author</th>
                  <th>Aspects</th>
                  </tr>
              </thead>
              <tbody>
                <UserFavoritesGridRows favorites={this.props.favorites} />
              </tbody>
              <tfoot>
              </tfoot>
          </table>

      </div>
      </div>
    );
  }
}

export default UserFavorites;



// WEBPACK FOOTER //
// ./src/Authentication/UserFavorites.js